import React, { useState, useEffect, useRef } from 'react'
import axios from 'axios'
import { useBrand } from '../context/BrandContext'
import { useNavigate } from 'react-router-dom'
import { colors, radius, s, ui } from '../styles/theme'

const API = process.env.REACT_APP_API_URL || 'http://localhost:3000'

const style = {
  card: s.card,
  input: s.input,
  label: s.labelNormal,
  savedNote: { fontSize: '13px', color: colors.textSecondary, margin: '0 0 16px' },
  code: { background: colors.bgPage, border: `1px solid ${colors.border}`, padding: '2px 6px', borderRadius: radius.sm, fontSize: '12px', color: colors.textPrimary }
}

function Influencers() {
  const { selectedBrand } = useBrand()
  const navigate = useNavigate()
  const [influencers, setInfluencers] = useState([])
  const [loading, setLoading] = useState(true)
  const [view, setView] = useState('list')
  const [selectedInfluencer, setSelectedInfluencer] = useState(null)
  const [campaigns, setCampaigns] = useState([])
  const [selectedCampaign, setSelectedCampaign] = useState(null)
  const [campaignOrders, setCampaignOrders] = useState([])
  const [campaignPayments, setCampaignPayments] = useState([])
  const [campaignStats, setCampaignStats] = useState(null)
  const [syncing, setSyncing] = useState(false)
  const [saved, setSaved] = useState(false)
  const [tab, setTab] = useState('list')
  const [applications, setApplications] = useState([])
  const [appCounts, setAppCounts] = useState({ bekliyor: 0, onaylandi: 0, reddedildi: 0 })
  const [appConfig, setAppConfig] = useState(null)
  const [appFilter, setAppFilter] = useState('bekliyor')
  const [appLoading, setAppLoading] = useState(false)
  const [appHata, setAppHata] = useState('')
  const [appConfigHata, setAppConfigHata] = useState(false)
  const markaRef = useRef(0)
  const basvuruRef = useRef(0)

  const token = localStorage.getItem('adminToken')
  const headers = { Authorization: token }

  useEffect(() => {
    if (!selectedBrand) return
    markaRef.current += 1
    setTab('list')
    setApplications([])
    setAppCounts({ bekliyor: 0, onaylandi: 0, reddedildi: 0 })
    setAppConfig(null)
    setAppHata('')
    setAppConfigHata(false)
    fetchInfluencers()
    fetchAppConfig()
  }, [selectedBrand?.id]) // eslint-disable-line

  useEffect(() => {
    if (!selectedBrand || tab !== 'applications') return
    fetchApplications()
  }, [selectedBrand?.id, tab, appFilter]) // eslint-disable-line

  function fetchInfluencers(secenek) {
    const sessiz = !!(secenek && secenek.sessiz === true)
    if (!sessiz) setLoading(true)
    axios.get(`${API}/admin/brands/${selectedBrand.id}/influencers`, { headers })
      .then(res => { setInfluencers(res.data); setLoading(false) })
      .catch(() => setLoading(false))
  }

  function fetchAppConfig() {
    const marka = markaRef.current
    axios.get(`${API}/admin/brands/${selectedBrand.id}/influencer-application-config`, { headers })
      .then(res => {
        if (marka !== markaRef.current) return
        setAppConfig(res.data || null)
        setAppConfigHata(false)
      })
      .catch(e => {
        if (marka !== markaRef.current) return
        setAppConfig(null)
        setAppConfigHata(!e.response || e.response.status >= 500)
      })
  }

  function fetchApplications() {
    const marka = markaRef.current
    const istek = (basvuruRef.current += 1)
    setAppLoading(true)
    setAppHata('')
    const q = appFilter === 'hepsi' ? '' : `?status=${appFilter}`
    axios.get(`${API}/admin/brands/${selectedBrand.id}/influencer-applications${q}`, { headers })
      .then(res => {
        if (marka !== markaRef.current || istek !== basvuruRef.current) return
        setApplications(res.data.applications || [])
        setAppCounts(res.data.counts || { bekliyor: 0, onaylandi: 0, reddedildi: 0 })
        setAppLoading(false)
      })
      .catch(() => {
        if (marka !== markaRef.current || istek !== basvuruRef.current) return
        setApplications([])
        setAppHata('Başvurular yüklenemedi. Sayfayı yenileyip tekrar deneyin.')
        setAppLoading(false)
      })
  }

  function fetchCampaigns(influencerId) {
    axios.get(`${API}/admin/influencers/${influencerId}/campaigns`, { headers })
      .then(res => setCampaigns(res.data))
  }

  function fetchCampaignDetail(campaign) {
    setSelectedCampaign(campaign)
    axios.get(`${API}/admin/campaigns/${campaign.id}/orders`, { headers }).then(res => setCampaignOrders(res.data))
    axios.get(`${API}/admin/campaigns/${campaign.id}/payments`, { headers }).then(res => setCampaignPayments(res.data))
    axios.get(`${API}/admin/campaigns/${campaign.id}/stats`, { headers }).then(res => setCampaignStats(res.data))
  }

  function showSaved() {
    setSaved(true)
    setTimeout(() => setSaved(false), 2500)
  }

  async function syncOrders() {
    setSyncing(true)
    try {
      await axios.post(`${API}/admin/brands/${selectedBrand.id}/sync-influencer-orders`, {}, { headers })
      if (selectedCampaign) fetchCampaignDetail(selectedCampaign)
      showSaved()
    } catch (e) { }
    setSyncing(false)
  }

  if (!selectedBrand) return (
    <div style={{ textAlign: 'center', padding: '60px' }}>
      <p style={{ ...ui.notice, display: 'inline-block', marginBottom: '16px' }}>Önce bir marka seçin.</p>
      <button onClick={() => navigate('/brands')} style={s.btnPrimary}>Markalara Git</button>
    </div>
  )

  if (loading) return <p style={ui.emptyText}>Yükleniyor...</p>

  if (selectedCampaign && view === 'campaign-detail') {
    return <CampaignDetail
      campaign={selectedCampaign}
      orders={campaignOrders}
      payments={campaignPayments}
      stats={campaignStats}
      influencer={selectedInfluencer}
      headers={headers}
      syncing={syncing}
      saved={saved}
      onSync={syncOrders}
      onBack={() => { setSelectedCampaign(null); setView('influencer-detail') }}
      onRefresh={() => fetchCampaignDetail(selectedCampaign)}
      onShowSaved={showSaved}
    />
  }

  if (selectedInfluencer && view === 'influencer-detail') {
    return <InfluencerDetail
      influencer={selectedInfluencer}
      campaigns={campaigns}
      brandId={selectedBrand.id}
      headers={headers}
      saved={saved}
      onBack={() => { setSelectedInfluencer(null); setView('list'); fetchInfluencers() }}
      onSelectCampaign={(c) => { fetchCampaignDetail(c); setView('campaign-detail') }}
      onRefreshCampaigns={() => fetchCampaigns(selectedInfluencer.id)}
      onShowSaved={showSaved}
      onUpdateInfluencer={fetchInfluencers}
    />
  }

  return (
    <div>
      <div className="sx-wrap" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px', flexWrap: 'wrap', gap: '12px' }}>
        <h2 style={s.pageTitle}>Influencer'lar — {selectedBrand.name}</h2>
        {tab === 'list' && (
          <button onClick={() => setView('add-influencer')} style={s.btnPrimary}>
            + Yeni Influencer
          </button>
        )}
      </div>

      {appConfig && (
        <div style={ui.tabBar}>
          <button style={ui.tab(tab === 'list')} onClick={() => setTab('list')}>Influencer'lar</button>
          <button style={ui.tab(tab === 'applications')} onClick={() => setTab('applications')}>
            Başvurular{appCounts.bekliyor > 0 ? ` (${appCounts.bekliyor})` : ''}
          </button>
          <button style={ui.tab(tab === 'settings')} onClick={() => setTab('settings')}>Form Ayarları</button>
        </div>
      )}

      {!appConfig && appConfigHata && (
        <p style={{ ...s.alertDanger, marginBottom: '16px' }}>
          Başvuru ayarları yüklenemedi, başvuru sekmeleri gösterilemiyor. Sayfayı yenileyin.
        </p>
      )}

      {saved && <p style={style.savedNote}>Kaydedildi ✓</p>}

      {tab === 'applications' && (
        <ApplicationsTab
          applications={applications}
          counts={appCounts}
          filter={appFilter}
          loading={appLoading}
          hata={appHata}
          brand={selectedBrand}
          headers={headers}
          onFilter={setAppFilter}
          onRefresh={() => { fetchApplications(); fetchInfluencers({ sessiz: true }) }}
          onShowSaved={showSaved}
        />
      )}

      {tab === 'settings' && (
        <ApplicationSettings
          key={selectedBrand.id}
          config={appConfig}
          brand={selectedBrand}
          headers={headers}
          onSaved={(yeni) => { setAppConfig(yeni); showSaved() }}
        />
      )}

      {tab === 'list' && view === 'add-influencer' && (
        <AddInfluencerForm
          brandId={selectedBrand.id}
          headers={headers}
          onSave={() => { fetchInfluencers(); setView('list'); showSaved() }}
          onCancel={() => setView('list')}
        />
      )}

      {tab === 'list' && influencers.length === 0 && view === 'list' && (
        <div style={{ ...style.card, textAlign: 'center', color: colors.textMuted, fontSize: '13px', padding: '48px' }}>
          Henüz influencer eklenmemiş.
        </div>
      )}

      {tab === 'list' && influencers.map(inf => (
        <div key={inf.id} style={style.card}>
          <div className="sx-wrap" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px' }}>
            <div>
              <p style={{ fontWeight: 600, fontSize: '15px', color: colors.textPrimary, letterSpacing: '-0.015em', margin: '0 0 4px' }}>{inf.name}</p>
              <p className="sx-break" style={{ color: colors.textSecondary, fontSize: '13px', margin: 0 }}>{inf.email}</p>
              {inf.notes && <p className="sx-break" style={{ color: colors.textMuted, fontSize: '12px', margin: '4px 0 0' }}>{inf.notes}</p>}
            </div>
            <div style={{ display: 'flex', gap: '12px', alignItems: 'center', flexWrap: 'wrap' }}>
              <span style={ui.status(inf.is_active)}><span style={ui.statusDot(inf.is_active)} />{inf.is_active ? 'Aktif' : 'Pasif'}</span>
              <button onClick={async () => {
                if (!window.confirm('Bu influencer ve tüm kampanyaları silinecek. Emin misiniz?')) return
                await axios.delete(`${API}/admin/influencers/${inf.id}`, { headers })
                fetchInfluencers()
              }} style={ui.btnDangerQuiet}>Sil</button>
              <button onClick={() => {
                setSelectedInfluencer(inf)
                fetchCampaigns(inf.id)
                setView('influencer-detail')
              }} style={ui.btnSm}>Detay & Kampanyalar</button>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

function AddInfluencerForm({ brandId, headers, onSave, onCancel }) {
  const [form, setForm] = useState({ name: '', email: '', notes: '' })

  async function handleSave() {
    if (!form.name || !form.email) return alert('Ad ve email zorunlu')
    await axios.post(`${API}/admin/brands/${brandId}/influencers`, form, { headers })
    onSave()
  }

  return (
    <div style={{ ...style.card, border: `1px solid ${colors.primary}` }}>
      <h3 style={{ ...s.sectionTitle, margin: '0 0 20px' }}>Yeni Influencer</h3>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }}>
        <div>
          <label style={style.label}>Ad Soyad *</label>
          <input style={style.input} value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} placeholder="Ahmet Yılmaz" />
        </div>
        <div>
          <label style={style.label}>E-posta *</label>
          <input style={style.input} value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} placeholder="ahmet@email.com" />
        </div>
      </div>
      <div style={{ marginBottom: '20px' }}>
        <label style={style.label}>Not</label>
        <input style={style.input} value={form.notes} onChange={e => setForm({ ...form, notes: e.target.value })} placeholder="Opsiyonel not" />
      </div>
      <div style={{ display: 'flex', gap: '12px' }}>
        <button onClick={handleSave} style={s.btnPrimary}>Kaydet</button>
        <button onClick={onCancel} style={s.btnSecondary}>İptal</button>
      </div>
    </div>
  )
}

function InfluencerDetail({ influencer, campaigns, brandId, headers, saved, onBack, onSelectCampaign, onRefreshCampaigns, onShowSaved, onUpdateInfluencer }) {
  const [editMode, setEditMode] = useState(false)
  const [form, setForm] = useState({ ...influencer })
  const [showAddCampaign, setShowAddCampaign] = useState(false)

  async function handleUpdateInfluencer() {
    await axios.put(`${API}/admin/influencers/${influencer.id}`, form, { headers })
    setEditMode(false)
    onShowSaved()
    onUpdateInfluencer()
  }

  return (
    <div>
      <button onClick={onBack} style={{ ...ui.btnSm, marginBottom: '20px' }}>
        ← Geri
      </button>

      {saved && <p style={style.savedNote}>Kaydedildi ✓</p>}

      <div style={style.card}>
        {editMode ? (
          <div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }}>
              <div>
                <label style={style.label}>Ad Soyad</label>
                <input style={style.input} value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} />
              </div>
              <div>
                <label style={style.label}>E-posta</label>
                <input style={style.input} value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} />
              </div>
            </div>
            <div style={{ marginBottom: '16px' }}>
              <label style={style.label}>Not</label>
              <input style={style.input} value={form.notes || ''} onChange={e => setForm({ ...form, notes: e.target.value })} />
            </div>
            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px', marginBottom: '16px' }}>
              <input type="checkbox" checked={form.is_active} onChange={e => setForm({ ...form, is_active: e.target.checked })} />
              Aktif
            </label>
            <div style={{ display: 'flex', gap: '12px' }}>
              <button onClick={handleUpdateInfluencer} style={s.btnPrimary}>Kaydet</button>
              <button onClick={() => setEditMode(false)} style={s.btnSecondary}>İptal</button>
            </div>
          </div>
        ) : (
          <div className="sx-wrap" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px' }}>
            <div>
              <h2 style={{ ...s.pageTitle, margin: '0 0 4px' }}>{influencer.name}</h2>
              <p className="sx-break" style={{ color: colors.textSecondary, margin: 0, fontSize: '13px' }}>{influencer.email}</p>
              {influencer.notes && <p className="sx-break" style={{ color: colors.textMuted, fontSize: '12px', margin: '4px 0 0' }}>{influencer.notes}</p>}
            </div>
            <div style={{ display: 'flex', gap: '12px', alignItems: 'center', flexWrap: 'wrap' }}>
              <span style={ui.status(influencer.is_active)}><span style={ui.statusDot(influencer.is_active)} />{influencer.is_active ? 'Aktif' : 'Pasif'}</span>
              <button onClick={() => setEditMode(true)} style={ui.btnSm}>Düzenle</button>
            </div>
          </div>
        )}
      </div>

      <div className="sx-wrap" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px', flexWrap: 'wrap', gap: '12px' }}>
        <h3 style={s.sectionTitle}>Kampanyalar</h3>
        <button onClick={() => setShowAddCampaign(true)} style={s.btnPrimary}>+ Yeni Kampanya</button>
      </div>

      {showAddCampaign && (
        <AddCampaignForm
          influencerId={influencer.id}
          brandId={brandId}
          headers={headers}
          onSave={() => { setShowAddCampaign(false); onRefreshCampaigns(); onShowSaved() }}
          onCancel={() => setShowAddCampaign(false)}
        />
      )}

      {campaigns.length === 0 && !showAddCampaign && (
        <div style={{ ...style.card, textAlign: 'center', color: colors.textMuted, fontSize: '13px', padding: '32px' }}>Henüz kampanya yok.</div>
      )}

      {campaigns.map(c => (
        <div key={c.id} style={style.card}>
          <div className="sx-wrap" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px' }}>
            <div>
              <p style={{ fontWeight: 600, fontSize: '15px', color: colors.textPrimary, letterSpacing: '-0.015em', margin: '0 0 6px' }}>{c.name}</p>
              <div className="sx-break" style={{ display: 'flex', gap: '16px', fontSize: '13px', color: colors.textSecondary, alignItems: 'center', flexWrap: 'wrap' }}>
                <span>UTM: <code style={style.code}>{c.utm_code}</code></span>
                {c.coupon_code && <span>Kupon: <code style={style.code}>{c.coupon_code}</code></span>}
                <span>Komisyon: %{c.commission_rate}</span>
                <span>Başlangıç: {new Date(c.start_date).toLocaleDateString('tr-TR')}</span>
              </div>
            </div>
            <div style={{ display: 'flex', gap: '12px', alignItems: 'center', flexWrap: 'wrap' }}>
              <span style={ui.status(c.is_active)}><span style={ui.statusDot(c.is_active)} />{c.is_active ? 'Aktif' : 'Pasif'}</span>
              <button onClick={async () => {
                if (!window.confirm('Bu kampanya ve tüm siparişler silinecek. Emin misiniz?')) return
                await axios.delete(`${API}/admin/campaigns/${c.id}`, { headers })
                onRefreshCampaigns()
              }} style={ui.btnDangerQuiet}>Sil</button>
              <button onClick={() => onSelectCampaign(c)} style={ui.btnSm}>Detay & Raporlar</button>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

function AddCampaignForm({ influencerId, brandId, headers, onSave, onCancel }) {
  const [form, setForm] = useState({
    name: '', utm_code: '', coupon_code: '', commission_rate: 10, landing_url: '',
    share_link: true, share_coupon: true,
    start_date: new Date().toISOString().split('T')[0],
    daily_report_enabled: true, report_time: '23:00'
  })

  async function handleSave() {
    if (!form.name || !form.utm_code) return alert('Kampanya adı ve UTM kodu zorunlu')
    await axios.post(`${API}/admin/influencers/${influencerId}/campaigns`, { ...form, brand_id: brandId }, { headers })
    onSave()
  }

  return (
    <div style={{ ...style.card, border: `1px solid ${colors.primary}`, marginBottom: '16px' }}>
      <h3 style={{ ...s.sectionTitle, margin: '0 0 20px' }}>Yeni Kampanya</h3>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }}>
        <div>
          <label style={style.label}>Kampanya Adı *</label>
          <input style={style.input} value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} placeholder="Yaz Kampanyası 2026" />
        </div>
        <div>
          <label style={style.label}>UTM Kodu * <span style={{ color: colors.textMuted, fontWeight: 400 }}>(benzersiz)</span></label>
          <input style={style.input} value={form.utm_code} onChange={e => setForm({ ...form, utm_code: e.target.value })} placeholder="ahmet_yaz2026" />
        </div>
        <div>
          <label style={style.label}>Kupon Kodu <span style={{ color: colors.textMuted, fontWeight: 400 }}>(opsiyonel)</span></label>
          <input style={style.input} value={form.coupon_code} onChange={e => setForm({ ...form, coupon_code: e.target.value })} placeholder="AHMET15" />
        </div>
        <div style={{ gridColumn: '1 / -1' }}>
          <label style={style.label}>Kampanya Sayfası Linki <span style={{ color: colors.textMuted, fontWeight: 400 }}>(opsiyonel — boşsa ana sayfa kullanılır)</span></label>
          <input style={style.input} value={form.landing_url} onChange={e => setForm({ ...form, landing_url: e.target.value })} placeholder="https://siteniz.com/cocuk" />
          <p style={{ fontSize: '11.5px', color: colors.textMuted, margin: '4px 0 0' }}>Influencer’a gidecek mailde UTM parametreleri bu adresin sonuna eklenir.</p>
        </div>
        <div style={{ gridColumn: '1 / -1', ...s.cardFlat, padding: '14px' }}>
          <label style={style.label}>Kampanya Modeli <span style={{ color: colors.textMuted, fontWeight: 400 }}>(mailde yalnızca seçtikleriniz görünür)</span></label>
          <div style={{ display: 'flex', gap: '24px', marginTop: '8px', flexWrap: 'wrap' }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px', cursor: 'pointer' }}>
              <input type="checkbox" checked={form.share_link !== false} onChange={e => setForm({ ...form, share_link: e.target.checked })} />
              Link Paylaşımı
            </label>
            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px', cursor: 'pointer' }}>
              <input type="checkbox" checked={form.share_coupon !== false} onChange={e => setForm({ ...form, share_coupon: e.target.checked })} />
              Kupon Kodu Paylaşımı
            </label>
          </div>
        </div>
        <div>
          <label style={style.label}>Komisyon Oranı (%)</label>
          <input type="number" style={style.input} value={form.commission_rate} onChange={e => setForm({ ...form, commission_rate: parseFloat(e.target.value) })} />
        </div>
        <div>
          <label style={style.label}>Başlangıç Tarihi</label>
          <input type="date" style={style.input} value={form.start_date} onChange={e => setForm({ ...form, start_date: e.target.value })} />
        </div>
        <div>
          <label style={style.label}>Günlük Rapor Saati</label>
          <input type="time" style={style.input} value={form.report_time} onChange={e => setForm({ ...form, report_time: e.target.value })} />
        </div>
      </div>
      <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px', marginBottom: '20px' }}>
        <input type="checkbox" checked={form.daily_report_enabled} onChange={e => setForm({ ...form, daily_report_enabled: e.target.checked })} />
        Günlük mail raporu gönder
      </label>
      <div style={{ display: 'flex', gap: '12px' }}>
        <button onClick={handleSave} style={s.btnPrimary}>Kaydet</button>
        <button onClick={onCancel} style={s.btnSecondary}>İptal</button>
      </div>
    </div>
  )
}

function CampaignDetail({ campaign, orders, payments, stats, influencer, headers, syncing, saved, onSync, onBack, onRefresh, onShowSaved }) {
  const [editMode, setEditMode] = useState(false)
  const [form, setForm] = useState({ ...campaign })
  const [showAddPayment, setShowAddPayment] = useState(false)
  const [paymentForm, setPaymentForm] = useState({ amount: '', paid_at: new Date().toISOString().split('T')[0], notes: '' })

  const fmt = n => parseFloat(n || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2 }) + ' ₺'

  async function handleUpdateCampaign() {
    await axios.put(`${API}/admin/campaigns/${campaign.id}`, form, { headers })
    setEditMode(false)
    onShowSaved()
  }

  async function handleAddPayment() {
    if (!paymentForm.amount) return alert('Tutar zorunlu')
    await axios.post(`${API}/admin/campaigns/${campaign.id}/payments`, paymentForm, { headers })
    setShowAddPayment(false)
    setPaymentForm({ amount: '', paid_at: new Date().toISOString().split('T')[0], notes: '' })
    onRefresh()
    onShowSaved()
  }

  async function handleDeletePayment(paymentId) {
    if (!window.confirm('Bu ödemeyi silmek istediğinize emin misiniz?')) return
    await axios.delete(`${API}/admin/payments/${paymentId}`, { headers })
    onRefresh()
  }

  return (
    <div>
      <button onClick={onBack} style={{ ...ui.btnSm, marginBottom: '20px' }}>
        ← {influencer?.name} — Kampanyalara Dön
      </button>

      {saved && <p style={style.savedNote}>Kaydedildi ✓</p>}

      <div style={style.card}>
        {editMode ? (
          <div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }}>
              <div><label style={style.label}>Kampanya Adı</label><input style={style.input} value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} /></div>
              <div><label style={style.label}>UTM Kodu</label><input style={style.input} value={form.utm_code} onChange={e => setForm({ ...form, utm_code: e.target.value })} /></div>
              <div><label style={style.label}>Kupon Kodu</label><input style={style.input} value={form.coupon_code || ''} onChange={e => setForm({ ...form, coupon_code: e.target.value })} /></div>
              <div style={{ gridColumn: '1 / -1' }}><label style={style.label}>Kampanya Sayfası Linki <span style={{ color: colors.textMuted, fontWeight: 400 }}>(boşsa ana sayfa)</span></label><input style={style.input} value={form.landing_url || ''} onChange={e => setForm({ ...form, landing_url: e.target.value })} placeholder="https://siteniz.com/cocuk" /></div>
        <div style={{ gridColumn: '1 / -1', ...s.cardFlat, padding: '14px' }}>
          <label style={style.label}>Kampanya Modeli <span style={{ color: colors.textMuted, fontWeight: 400 }}>(mailde yalnızca seçtikleriniz görünür)</span></label>
          <div style={{ display: 'flex', gap: '24px', marginTop: '8px', flexWrap: 'wrap' }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px', cursor: 'pointer' }}>
              <input type="checkbox" checked={form.share_link !== false} onChange={e => setForm({ ...form, share_link: e.target.checked })} />
              Link Paylaşımı
            </label>
            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px', cursor: 'pointer' }}>
              <input type="checkbox" checked={form.share_coupon !== false} onChange={e => setForm({ ...form, share_coupon: e.target.checked })} />
              Kupon Kodu Paylaşımı
            </label>
          </div>
        </div>
              <div><label style={style.label}>Komisyon (%)</label><input type="number" style={style.input} value={form.commission_rate} onChange={e => setForm({ ...form, commission_rate: parseFloat(e.target.value) })} /></div>
              <div><label style={style.label}>Başlangıç Tarihi</label><input type="date" style={style.input} value={form.start_date?.split('T')[0]} onChange={e => setForm({ ...form, start_date: e.target.value })} /></div>
              <div><label style={style.label}>Rapor Saati</label><input type="time" style={style.input} value={form.report_time} onChange={e => setForm({ ...form, report_time: e.target.value })} /></div>
            </div>
            <div style={{ display: 'flex', gap: '24px', marginBottom: '16px', flexWrap: 'wrap' }}>
              <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px' }}>
                <input type="checkbox" checked={form.daily_report_enabled} onChange={e => setForm({ ...form, daily_report_enabled: e.target.checked })} />
                Günlük rapor gönder
              </label>
              <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px' }}>
                <input type="checkbox" checked={form.is_active} onChange={e => setForm({ ...form, is_active: e.target.checked })} />
                Aktif
              </label>
            </div>
            <div style={{ display: 'flex', gap: '12px' }}>
              <button onClick={handleUpdateCampaign} style={s.btnPrimary}>Kaydet</button>
              <button onClick={() => setEditMode(false)} style={s.btnSecondary}>İptal</button>
            </div>
          </div>
        ) : (
          <div className="sx-wrap" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '12px' }}>
            <div>
              <h2 style={{ ...s.pageTitle, margin: '0 0 8px' }}>{campaign.name}</h2>
              <div className="sx-break" style={{ display: 'flex', gap: '16px', fontSize: '13px', color: colors.textSecondary, flexWrap: 'wrap', alignItems: 'center' }}>
                <span>UTM: <code style={style.code}>{campaign.utm_code}</code></span>
                {campaign.coupon_code && <span>Kupon: <code style={style.code}>{campaign.coupon_code}</code></span>}
                <span>Komisyon: %{campaign.commission_rate}</span>
                <span>Başlangıç: {new Date(campaign.start_date).toLocaleDateString('tr-TR')}</span>
                <span>Rapor: {campaign.daily_report_enabled ? `✓ ${campaign.report_time}` : '✗'}</span>
              </div>
            </div>
            <div style={{ display: 'flex', gap: '12px', alignItems: 'center', flexWrap: 'wrap' }}>
              <span style={ui.status(campaign.is_active)}><span style={ui.statusDot(campaign.is_active)} />{campaign.is_active ? 'Aktif' : 'Pasif'}</span>
              <button onClick={() => setEditMode(true)} style={ui.btnSm}>Düzenle</button>
              <button onClick={onSync} disabled={syncing} style={{ ...s.btnPrimary, opacity: syncing ? 0.55 : 1, cursor: syncing ? 'default' : 'pointer' }}>
                {syncing ? 'Sync...' : '↻ Siparişleri Güncelle'}
              </button>
            </div>
          </div>
        )}
      </div>

      {stats && (
        <div className="sx-grid-stat" style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: '12px', marginBottom: '16px' }}>
          {[
            { label: 'Bugün Sipariş', value: stats.today_count },
            { label: 'Bugün Komisyon', value: fmt(stats.today_commission) },
            { label: 'Toplam Komisyon', value: fmt(stats.total_commission) },
            { label: 'Kesinleşen Komisyon', value: fmt(stats.confirmed_commission) },
            { label: 'Kalan Bakiye', value: fmt(stats.balance) }
          ].map((m, i) => (
            <div key={i} style={ui.statBox}>
              <div style={{ ...ui.statValue, fontSize: '20px', margin: 0 }}>{m.value}</div>
              <div style={{ ...ui.statLabel, marginTop: '6px' }}>{m.label}</div>
            </div>
          ))}
        </div>
      )}

      <div style={style.card}>
        <div className="sx-wrap" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px', flexWrap: 'wrap', gap: '12px' }}>
          <h3 style={s.sectionTitle}>Hakediş Ödemeleri</h3>
          <button onClick={() => setShowAddPayment(true)} style={ui.btnSm}>+ Ödeme Ekle</button>
        </div>

        {showAddPayment && (
          <div style={{ ...s.cardFlat, padding: '16px', marginBottom: '16px' }}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 2fr', gap: '12px', marginBottom: '12px' }}>
              <div>
                <label style={style.label}>Tutar (₺)</label>
                <input type="number" style={style.input} value={paymentForm.amount} onChange={e => setPaymentForm({ ...paymentForm, amount: e.target.value })} placeholder="0.00" />
              </div>
              <div>
                <label style={style.label}>Ödeme Tarihi</label>
                <input type="date" style={style.input} value={paymentForm.paid_at} onChange={e => setPaymentForm({ ...paymentForm, paid_at: e.target.value })} />
              </div>
              <div>
                <label style={style.label}>Not</label>
                <input style={style.input} value={paymentForm.notes} onChange={e => setPaymentForm({ ...paymentForm, notes: e.target.value })} placeholder="Opsiyonel not" />
              </div>
            </div>
            <div style={{ display: 'flex', gap: '12px' }}>
              <button onClick={handleAddPayment} style={ui.btnPrimarySm}>Kaydet</button>
              <button onClick={() => setShowAddPayment(false)} style={ui.btnSm}>İptal</button>
            </div>
          </div>
        )}

        {payments.length === 0 ? (
          <p style={ui.emptyText}>Henüz ödeme yapılmamış.</p>
        ) : (
          <div className="sx-scroll-x">
          <table style={s.table}>
            <thead>
              <tr>
                <th style={s.th}>Tarih</th>
                <th style={{ ...s.th, textAlign: 'right' }}>Tutar</th>
                <th style={s.th}>Not</th>
                <th style={s.th}></th>
              </tr>
            </thead>
            <tbody>
              {payments.map(p => (
                <tr key={p.id}>
                  <td style={s.td}>{new Date(p.paid_at).toLocaleDateString('tr-TR')}</td>
                  <td style={{ ...s.td, ...ui.num, textAlign: 'right' }}>- {fmt(p.amount)}</td>
                  <td style={{ ...s.td, color: colors.textSecondary }}>{p.notes || '-'}</td>
                  <td style={{ ...s.td, textAlign: 'center' }}>
                    <button onClick={() => handleDeletePayment(p.id)} style={ui.btnDangerQuiet}>Sil</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
        )}
      </div>

      <div style={style.card}>
        <h3 style={{ ...s.sectionTitle, margin: '0 0 16px' }}>Siparişler ({orders.length})</h3>
        {orders.length === 0 ? (
          <p style={ui.emptyText}>Henüz sipariş yok. Siparişleri güncellemek için "Siparişleri Güncelle" butonunu kullanın.</p>
        ) : (
          <div className="sx-scroll-x">
          <table className="sx-cards" style={s.table}>
            <thead>
              <tr>
                <th style={s.th}>Sipariş Kodu</th>
                <th style={s.th}>Tarih</th>
                <th style={s.th}>Satın Alınan Oturum</th>
                <th style={s.th}>Kullanılan Kampanya</th>
                <th style={{ ...s.th, textAlign: 'right' }}>Tutar</th>
                <th style={{ ...s.th, textAlign: 'right' }}>Komisyon</th>
                <th style={s.th}>Durum</th>
              </tr>
            </thead>
            <tbody>
              {orders.map(o => {
                const isUtm = o.utm_source && campaign.utm_code &&
                  o.utm_source.toLowerCase() === campaign.utm_code.toLowerCase()
                const isCoupon = o.voucher_code && campaign.coupon_code &&
                  o.voucher_code.toLowerCase() === campaign.coupon_code.toLowerCase()
                const campaignType = isUtm ? 'UTM Paylaşımı' : isCoupon ? `Kupon Kodu: ${o.voucher_code}` : '-'

                return (
                  <tr key={o.id}>
                    <td data-label="Sipariş Kodu" style={{ ...s.td, fontFamily: 'monospace' }}>{o.order_code}</td>
                    <td data-label="Tarih" style={{ ...s.td, color: colors.textSecondary }}>{new Date(o.order_date).toLocaleDateString('tr-TR')}</td>
                    <td data-label="Satın Alınan Oturum" style={{ ...s.td, color: colors.textSecondary }}>{o.utm_source || '-'}</td>
                    <td data-label="Kullanılan Kampanya" style={s.td}>
                      <span style={ui.chip}>{campaignType}</span>
                    </td>
                    <td data-label="Tutar" style={{ ...s.td, ...ui.num, textAlign: 'right' }}>{fmt(o.order_amount)}</td>
                    <td data-label="Komisyon" style={{ ...s.td, ...ui.numMuted, textAlign: 'right' }}>{fmt(o.commission_amount)}</td>
                    <td data-label="Durum" style={s.td}>
                      <span style={ui.chip}>{o.order_status}</span>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
          </div>
        )}
      </div>
    </div>
  )
}

const BASVURU_DURUM = {
  bekliyor: { etiket: 'Bekliyor', stil: 'badgeWarning' },
  onaylandi: { etiket: 'Onaylandı', stil: 'badgeSuccess' },
  reddedildi: { etiket: 'Reddedildi', stil: 'badgeDanger' }
}

const TR_ASCII = { ç: 'c', ğ: 'g', ı: 'i', ö: 'o', ş: 's', ü: 'u', Ç: 'c', Ğ: 'g', İ: 'i', Ö: 'o', Ş: 's', Ü: 'u' }

function asciiKod(v, ayirici) {
  const duz = String(v || '').split('').map(c => (TR_ASCII[c] !== undefined ? TR_ASCII[c] : c)).join('')
  let temiz = duz.toLowerCase().replace(/[^a-z0-9]+/g, () => String(ayirici || ''))
  if (!ayirici) return temiz
  while (temiz.startsWith(ayirici)) temiz = temiz.slice(ayirici.length)
  while (temiz.endsWith(ayirici)) temiz = temiz.slice(0, -ayirici.length)
  return temiz
}

function basvuruTarihi(v) {
  if (!v) return ''
  try {
    return new Intl.DateTimeFormat('tr-TR', {
      timeZone: 'Europe/Istanbul', day: '2-digit', month: '2-digit', year: 'numeric',
      hour: '2-digit', minute: '2-digit'
    }).format(new Date(v))
  } catch (e) { return '' }
}

function ApplicationsTab({ applications, counts, filter, loading, hata, brand, headers, onFilter, onRefresh, onShowSaved }) {
  const [onaylanan, setOnaylanan] = useState(null)
  const [isleniyor, setIsleniyor] = useState(null)

  const suzgecler = [
    ['bekliyor', `Bekleyen (${counts.bekliyor})`],
    ['onaylandi', `Onaylanan (${counts.onaylandi})`],
    ['reddedildi', `Reddedilen (${counts.reddedildi})`],
    ['hepsi', 'Hepsi']
  ]

  async function reddet(basvuru) {
    const not = window.prompt(
      `${basvuru.name} başvurusu reddedilecek ve kendisine olumsuz geri bildirim maili gidecek.\n\n` +
      'İsterseniz panelde kalacak bir iç not yazabilirsiniz (zorunlu değil):', ''
    )
    if (not === null) return
    setIsleniyor(basvuru.id)
    try {
      await axios.post(`${API}/admin/influencer-applications/${basvuru.id}/reject`, { note: not }, { headers })
      onShowSaved()
      onRefresh()
    } catch (e) {
      alert(e.response?.data?.error || 'Başvuru reddedilemedi')
      if (e.response?.status === 409) onRefresh()
    }
    setIsleniyor(null)
  }

  const alan = (etiket, deger, link) => {
    if (!String(deger || '').trim()) return null
    return (
      <div style={{ minWidth: '160px' }}>
        <p style={{ fontSize: '11px', color: colors.textMuted, margin: '0 0 2px' }}>{etiket}</p>
        <p className="sx-break" style={{ fontSize: '13px', color: colors.textPrimary, margin: 0, fontWeight: 500 }}>
          {link ? <a href={link} target="_blank" rel="noreferrer" style={{ color: colors.primary, textDecoration: 'none' }}>{deger}</a> : deger}
        </p>
      </div>
    )
  }

  return (
    <div>
      <div className="sx-wrap" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '12px', flexWrap: 'wrap', marginBottom: '18px' }}>
        <div style={{ ...ui.segmented, maxWidth: '100%' }}>
          {suzgecler.map(([anahtar, etiket]) => (
            <button key={anahtar} onClick={() => onFilter(anahtar)} style={ui.segmentedBtn(filter === anahtar)}>
              {etiket}
            </button>
          ))}
        </div>
        <button onClick={onRefresh} style={s.btnSecondary}>Yenile</button>
      </div>

      {hata && <p style={{ ...s.alertDanger, marginBottom: '16px' }}>{hata}</p>}

      {loading && <p style={ui.emptyText}>Yükleniyor...</p>}

      {!loading && !hata && applications.length === 0 && (
        <div style={{ ...style.card, textAlign: 'center', color: colors.textMuted, fontSize: '13px', padding: '48px' }}>
          Seçili durumda başvuru yok.
        </div>
      )}

      {!loading && applications.map(b => {
        const d = BASVURU_DURUM[b.status] || BASVURU_DURUM.bekliyor
        return (
          <div key={b.id} style={style.card}>
            <div className="sx-wrap" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '12px', marginBottom: '14px' }}>
              <div>
                <p style={{ fontWeight: 600, fontSize: '15px', color: colors.textPrimary, letterSpacing: '-0.015em', margin: '0 0 4px' }}>
                  {b.name}
                </p>
                <p style={{ color: colors.textMuted, fontSize: '12px', margin: 0 }}>
                  #{b.id} · {basvuruTarihi(b.created_at)}
                </p>
              </div>
              <div style={{ display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap' }}>
                <span style={s[d.stil]}>{d.etiket}</span>
                {b.status === 'bekliyor' && (
                  <>
                    <button disabled={isleniyor === b.id} onClick={() => reddet(b)} style={ui.btnDangerQuiet}>Reddet</button>
                    <button disabled={isleniyor === b.id} onClick={() => setOnaylanan(b)} style={s.btnPrimary}>Onayla</button>
                  </>
                )}
              </div>
            </div>

            <div style={{ display: 'flex', gap: '24px', flexWrap: 'wrap', rowGap: '14px' }}>
              {alan('E-posta', b.email, `mailto:${b.email}`)}
              {alan('Telefon', b.phone, `tel:${String(b.phone || '').replace(/[^0-9+]/g, '')}`)}
              {alan('Şehir', b.city)}
              {alan('Instagram', b.instagram)}
              {alan('TikTok', b.tiktok)}
              {alan('YouTube', b.youtube)}
              {alan('Diğer', b.other_link)}
              {alan('Takipçi', b.follower_count)}
              {alan('İçerik alanı', b.audience)}
            </div>

            {b.message && (
              <div style={{ ...s.cardFlat, padding: '12px 14px', marginTop: '14px', fontSize: '13px', color: colors.textSecondary, whiteSpace: 'pre-wrap' }}>
                {b.message}
              </div>
            )}

            <div style={{ display: 'flex', gap: '14px', flexWrap: 'wrap', marginTop: '14px', fontSize: '11.5px', color: colors.textMuted }}>
              <span>KVKK onayı: {b.kvkk ? 'var' : 'yok'}</span>
              {b.ip && <span>IP: {b.ip}</span>}
              <span>Alındı maili: {b.ack_sent ? 'gitti' : (b.ack_error || 'gitmedi')}</span>
              <span>Yönetici bildirimi: {b.notify_sent ? 'gitti' : (b.notify_error || 'gitmedi')}</span>
              {b.status !== 'bekliyor' && (
                <span>Sonuç maili: {b.result_sent ? 'gitti' : (b.result_error || 'gitmedi')}</span>
              )}
              {b.decided_by && <span>Karar: {b.decided_by} · {basvuruTarihi(b.decided_at)}</span>}
            </div>

            {b.decision_note && (
              <p style={{ fontSize: '12px', color: colors.textMuted, margin: '10px 0 0' }}>İç not: {b.decision_note}</p>
            )}
          </div>
        )
      })}

      {onaylanan && (
        <ApproveDialog
          application={onaylanan}
          brand={brand}
          headers={headers}
          onClose={() => setOnaylanan(null)}
          onDone={() => { setOnaylanan(null); onShowSaved(); onRefresh() }}
          onConflict={onRefresh}
        />
      )}
    </div>
  )
}

function ApproveDialog({ application, brand, headers, onClose, onDone, onConflict }) {
  const kod = asciiKod(application.name, '_')
  const [form, setForm] = useState({
    name: application.name || '',
    email: application.email || '',
    notes: [application.instagram, application.tiktok, application.youtube, application.other_link]
      .filter(x => String(x || '').trim()).join(' · '),
    note: '',
    campaign: {
      name: `${application.name} İş Ortaklığı`,
      utm_code: kod,
      coupon_code: asciiKod(application.name, '').toUpperCase().slice(0, 12),
      commission_rate: 10,
      landing_url: brand.site_url || '',
      start_date: new Date().toLocaleDateString('en-CA', { timeZone: 'Europe/Istanbul' }),
      report_time: '23:00',
      daily_report_enabled: true,
      share_link: true,
      share_coupon: true
    }
  })
  const [kaydediliyor, setKaydediliyor] = useState(false)
  const [hata, setHata] = useState('')

  const k = form.campaign
  const setK = (y) => setForm({ ...form, campaign: { ...form.campaign, ...y } })

  const eksikAlanlar = []
  if (!String(form.name).trim()) eksikAlanlar.push('Ad Soyad')
  if (!String(form.email).trim()) eksikAlanlar.push('E-posta')
  if (!String(k.name).trim()) eksikAlanlar.push('Kampanya adı')
  if (!String(k.utm_code).trim()) eksikAlanlar.push('UTM kodu')
  if (!String(k.coupon_code).trim()) eksikAlanlar.push('Kupon kodu')
  if (!(Number(k.commission_rate) > 0 && Number(k.commission_rate) <= 100)) eksikAlanlar.push('Komisyon (0 ile 100 arası)')
  if (!String(k.start_date).trim()) eksikAlanlar.push('Başlangıç tarihi')
  if (!String(k.report_time).trim()) eksikAlanlar.push('Rapor saati')
  if (!String(k.landing_url).trim()) eksikAlanlar.push('Kampanya sayfası linki')
  const eksik = eksikAlanlar.length > 0

  async function onayla() {
    setHata('')
    setKaydediliyor(true)
    try {
      await axios.post(`${API}/admin/influencer-applications/${application.id}/approve`, form, { headers })
      onDone()
    } catch (e) {
      setHata(e.response?.data?.error || 'Başvuru onaylanamadı')
      setKaydediliyor(false)
      if (e.response?.status === 409 && onConflict) onConflict()
    }
  }

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(17,24,39,0.45)', zIndex: 60,
      display: 'flex', alignItems: 'flex-start', justifyContent: 'center', padding: '32px 16px', overflowY: 'auto'
    }}>
      <div style={{ ...style.card, maxWidth: '760px', width: '100%', margin: 0 }}>
        <h3 style={{ ...s.sectionTitle, margin: '0 0 6px' }}>Başvuruyu onayla — {application.name}</h3>
        <p style={{ fontSize: '12.5px', color: colors.textSecondary, margin: '0 0 20px' }}>
          Onayladığınızda influencer kaydı ve aşağıdaki kampanya otomatik oluşturulur, ardından
          influencer'a kampanya bilgilerini içeren hoş geldiniz maili gider. Tüm alanlar zorunludur;
          önerilen değerleri göndermeden önce düzenleyebilirsiniz.
        </p>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }}>
          <div>
            <label style={style.label}>Ad Soyad *</label>
            <input style={style.input} value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} />
          </div>
          <div>
            <label style={style.label}>E-posta *</label>
            <input style={style.input} value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} />
          </div>
          <div style={{ gridColumn: '1 / -1' }}>
            <label style={style.label}>Influencer notu</label>
            <input style={style.input} value={form.notes} onChange={e => setForm({ ...form, notes: e.target.value })} />
          </div>
        </div>

        <div style={{ ...s.cardFlat, padding: '16px', marginBottom: '16px' }}>
          <p style={{ fontSize: '13px', fontWeight: 600, color: colors.textPrimary, margin: '0 0 14px' }}>Kampanya</p>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
            <div>
              <label style={style.label}>Kampanya Adı *</label>
              <input style={style.input} value={k.name} onChange={e => setK({ name: e.target.value })} />
            </div>
            <div>
              <label style={style.label}>UTM Kodu *</label>
              <input style={style.input} value={k.utm_code} onChange={e => setK({ utm_code: e.target.value })} />
            </div>
            <div>
              <label style={style.label}>Kupon Kodu *</label>
              <input style={style.input} value={k.coupon_code} onChange={e => setK({ coupon_code: e.target.value })} />
            </div>
            <div>
              <label style={style.label}>Komisyon Oranı (%) *</label>
              <input type="number" style={style.input} value={k.commission_rate} onChange={e => setK({ commission_rate: e.target.value })} />
            </div>
            <div style={{ gridColumn: '1 / -1' }}>
              <label style={style.label}>Kampanya Sayfası Linki *</label>
              <input style={style.input} value={k.landing_url} onChange={e => setK({ landing_url: e.target.value })} />
              <p style={{ fontSize: '11.5px', color: colors.textMuted, margin: '4px 0 0' }}>
                Maildeki UTM parametreleri bu adresin sonuna eklenir.
              </p>
            </div>
            <div>
              <label style={style.label}>Başlangıç Tarihi *</label>
              <input type="date" style={style.input} value={k.start_date} onChange={e => setK({ start_date: e.target.value })} />
            </div>
            <div>
              <label style={style.label}>Günlük Rapor Saati *</label>
              <input type="time" style={style.input} value={k.report_time} onChange={e => setK({ report_time: e.target.value })} />
            </div>
          </div>
          <div style={{ display: 'flex', gap: '24px', flexWrap: 'wrap', marginTop: '16px' }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px', cursor: 'pointer' }}>
              <input type="checkbox" checked={k.share_link !== false} onChange={e => setK({ share_link: e.target.checked })} />
              Link Paylaşımı
            </label>
            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px', cursor: 'pointer' }}>
              <input type="checkbox" checked={k.share_coupon !== false} onChange={e => setK({ share_coupon: e.target.checked })} />
              Kupon Kodu Paylaşımı
            </label>
            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px', cursor: 'pointer' }}>
              <input type="checkbox" checked={k.daily_report_enabled !== false} onChange={e => setK({ daily_report_enabled: e.target.checked })} />
              Günlük mail raporu
            </label>
          </div>
        </div>

        <div style={{ marginBottom: '20px' }}>
          <label style={style.label}>Karar notu <span style={{ color: colors.textMuted, fontWeight: 400 }}>(panelde kalır, maile girmez)</span></label>
          <input style={style.input} value={form.note} onChange={e => setForm({ ...form, note: e.target.value })} />
        </div>

        {hata && <p style={{ ...s.alertDanger, marginBottom: '16px' }}>{hata}</p>}

        <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap', alignItems: 'center' }}>
          <button
            disabled={eksik || kaydediliyor}
            onClick={onayla}
            style={{ ...s.btnPrimary, opacity: (eksik || kaydediliyor) ? 0.5 : 1, cursor: (eksik || kaydediliyor) ? 'default' : 'pointer' }}
          >
            {kaydediliyor ? 'Oluşturuluyor...' : 'Onayla ve kampanyayı oluştur'}
          </button>
          <button disabled={kaydediliyor} onClick={onClose} style={s.btnSecondary}>İptal</button>
          {eksik && !kaydediliyor && (
            <p style={{ fontSize: '12px', color: colors.textMuted, margin: 0 }}>
              Eksik alan: {eksikAlanlar.join(', ')}
            </p>
          )}
        </div>
      </div>
    </div>
  )
}

function ApplicationSettings({ config, brand, headers, onSaved }) {
  const [form, setForm] = useState({
    is_enabled: !!config.is_enabled,
    recipients: config.recipients || '',
    contact_email: config.contact_email || '',
    kvkk_text: config.kvkk_text || '',
    ack_subject: config.ack_subject || '',
    ack_body: config.ack_body || '',
    reject_subject: config.reject_subject || '',
    reject_body: config.reject_body || ''
  })
  const [kaydediliyor, setKaydediliyor] = useState(false)
  const [hata, setHata] = useState('')

  async function kaydet() {
    setHata('')
    setKaydediliyor(true)
    try {
      const r = await axios.put(`${API}/admin/brands/${brand.id}/influencer-application-config`, form, { headers })
      onSaved(r.data)
    } catch (e) {
      setHata(e.response?.data?.error || 'Kaydedilemedi')
    }
    setKaydediliyor(false)
  }

  const cokSatir = { ...style.input, minHeight: '92px', resize: 'vertical', lineHeight: 1.6, padding: '10px 12px' }

  return (
    <div style={style.card}>
      <h3 style={{ ...s.sectionTitle, margin: '0 0 6px' }}>Ön Başvuru Formu Ayarları</h3>
      <p style={{ fontSize: '12.5px', color: colors.textSecondary, margin: '0 0 20px' }}>
        Form kapalıyken sitedeki form gönderim kabul etmez ve hiçbir kayıt oluşmaz.
      </p>

      <label style={{ display: 'flex', alignItems: 'center', gap: '10px', fontSize: '14px', marginBottom: '20px' }}>
        <input type="checkbox" checked={form.is_enabled} onChange={e => setForm({ ...form, is_enabled: e.target.checked })} />
        Başvuru formu açık
      </label>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }}>
        <div>
          <label style={style.label}>Bildirim Alıcıları</label>
          <input style={style.input} value={form.recipients} onChange={e => setForm({ ...form, recipients: e.target.value })} placeholder="ornek@firma.com, ikinci@firma.com" />
          <p style={{ fontSize: '11.5px', color: colors.textMuted, margin: '4px 0 0' }}>Her yeni başvuru bu adreslere bildirilir. Boşsa yalnızca panelde görünür.</p>
        </div>
        <div>
          <label style={style.label}>Ret Mailindeki İletişim Adresi</label>
          <input style={style.input} value={form.contact_email} onChange={e => setForm({ ...form, contact_email: e.target.value })} placeholder="info@siteniz.com" />
        </div>
      </div>

      <div style={{ marginBottom: '16px' }}>
        <label style={style.label}>KVKK Onay Metni</label>
        <textarea style={cokSatir} value={form.kvkk_text} onChange={e => setForm({ ...form, kvkk_text: e.target.value })} placeholder="Boş bırakılırsa varsayılan metin kullanılır." />
        <p style={{ fontSize: '11.5px', color: colors.textMuted, margin: '4px 0 0' }}>
          Sitedeki formda gösterilen metinle birebir aynı olmalıdır; başvuruyla birlikte bu metin de kaydedilir.
        </p>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '16px', marginBottom: '16px' }}>
        <div>
          <label style={style.label}>"Başvurunuz Alındı" Maili — Konu</label>
          <input style={style.input} value={form.ack_subject} onChange={e => setForm({ ...form, ack_subject: e.target.value })} placeholder="Boşsa varsayılan konu kullanılır." />
        </div>
        <div>
          <label style={style.label}>"Başvurunuz Alındı" Maili — Metin</label>
          <textarea style={cokSatir} value={form.ack_body} onChange={e => setForm({ ...form, ack_body: e.target.value })} placeholder="Boşsa varsayılan metin kullanılır. Paragrafları boş satırla ayırın." />
        </div>
        <div>
          <label style={style.label}>Ret Maili — Konu</label>
          <input style={style.input} value={form.reject_subject} onChange={e => setForm({ ...form, reject_subject: e.target.value })} placeholder="Boşsa varsayılan konu kullanılır." />
        </div>
        <div>
          <label style={style.label}>Ret Maili — Metin</label>
          <textarea style={cokSatir} value={form.reject_body} onChange={e => setForm({ ...form, reject_body: e.target.value })} placeholder="Boşsa varsayılan metin kullanılır. İletişim adresi satırı sona otomatik eklenir." />
        </div>
      </div>

      <p style={{ fontSize: '12px', color: colors.textMuted, margin: '0 0 20px' }}>
        Onay maili, panelden kampanya eklendiğinde gönderilen hoş geldiniz mailinin aynısıdır; ayrı bir metni yoktur.
      </p>

      {hata && <p style={{ ...s.alertDanger, marginBottom: '16px' }}>{hata}</p>}

      <button disabled={kaydediliyor} onClick={kaydet} style={s.btnPrimary}>
        {kaydediliyor ? 'Kaydediliyor...' : 'Kaydet'}
      </button>
    </div>
  )
}

export default Influencers